import React, { useState } from "react";
import { Form, Input, Button, notification } from "antd";
import axios from "axios";
import { Link } from "react-router-dom";
import "./forgetPass.css";
import { useNavigate} from "react-router-dom";


// // Email Form Component
// const EmailForm = ({ setEmail, setStep, setLoading, loading }) => {
//   const handleEmailSubmit = async (values) => {
//     setLoading(true);
//     try {
//       console.log(values.email);
//       const resp = await axios.post("/auth/forgot-password", { username: values.email });
//       console.log(resp);

//       setLoading(false);
//       setEmail(values.email);
//       setStep(2);
//     } catch (error) {
//       setLoading(false);
//       notification.error({
//         message: "Error",
//         description: "Email not found. Please try again.",
//       });
//     }
//   };

//   return (
//     <Form onFinish={handleEmailSubmit}>
//       <Form.Item
//         name="email"
//         label="Email"
//         rules={[{ required: true, message: "Please enter your email" }]}
//       >
//         <Input />
//       </Form.Item>
//       <Button type="primary" htmlType="submit" loading={loading}>
//         Send OTP
//       </Button>
//     </Form>
//   );
// };

// // OTP Form Component
// const OtpForm = ({ email, setStep, setLoading, loading }) => {
//   const handleOtpSubmit = async (values) => {
//     setLoading(true);
//     try {
//       await axios.post("/auth/verify-otp", { ...values, email });
//       setLoading(false);
//       setStep(3);
//     } catch (error) {
//       setLoading(false);
//       notification.error({
//         message: "Error",
//         description: "Invalid OTP or OTP expired. Please try again.",
//       });
//     }
//   };

//   return (
//     <Form onFinish={handleOtpSubmit}>
//       <Form.Item
//         name="otp"
//         label="OTP"
//         rules={[{ required: true, message: "Please enter the OTP" }]}
//       >
//         <Input />
//       </Form.Item>
//       <Form.Item
//         name="newPassword"
//         label="New Password"
//         rules={[{ required: true, message: "Please enter your new password" }]}
//       >
//         <Input.Password />
//       </Form.Item>
//       <Button type="primary" htmlType="submit" loading={loading}>
//         Reset Password
//       </Button>
//     </Form>
//   );
// };

// // Main ForgotPassword Component
// const ForgotPassword = () => {
//   const [step, setStep] = useState(1);
//   const [email, setEmail] = useState("");
//   const [loading, setLoading] = useState(false);

//   return (
//     <div className="forgot-password-container">
//       {step === 1 && (
//         <EmailForm
//           setEmail={setEmail}
//           setStep={setStep}
//           setLoading={setLoading}
//           loading={loading}
//         />
//       )}
//       {step === 2 && (
//         <OtpForm
//           email={email}
//           setStep={setStep}
//           setLoading={setLoading}
//           loading={loading}
//         />
//       )}
//       {step === 3 && (
//         <div>
//           Password reset successful. Please <Link to="/">login</Link>.
//         </div>
//       )}
//     </div>
//   );
// };
// changes by sanskar
const ForgotPassword = () => {
   const navigate = useNavigate();

  const handleResetPassword = () =>{
    navigate("/reset-password");
  }
  return (
    
    <div className="login-container">
      <div className="logo">
        Surveyor's <span className="logo-icon">AI</span>
      </div>
      <h2 className="login-title">Sign into your account</h2>

      <div className="card">
        <form className="login-form">
          <input
            type="email"
            className="input-field"
            placeholder="Email Address"
            required
          />
          <button type="submit" className="verify-button" onClick={handleResetPassword}>
            Verify
          </button>
        </form>
      </div>

      <div className="card signup-card">
        <p>Dont have an account</p>
        <button className="signup-button">Sign up</button>
      </div>
    </div>
  );
}



export default ForgotPassword;
